<div mat-dialog-content>
    <div class="response-info">
        @if (data.value && data.value.isSuccessful) {
            <div>
                <mat-icon class="material-icons icon" color="primary">check_circle_outline</mat-icon>
            </div>
        }
        @if (data.value && data.value.message) {
            <p>{{ data.value.message }}</p>
        }

        @if (data.value.errors && data.value.errors.length > 0) {
            <table class="table table-hover">
                <tbody>
                    @for (e of data.value.errors; track e) {
                        <tr>
                            <td>{{ e.property }}</td>
                            <td>{{ e.error }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>{{ 'General.Ok' | translate }}</button>

    <ng-container
        [ngTemplateOutlet]="relatedActions.length === 1 ? singleAction : multipleOrEmpty"
        [ngTemplateOutletContext]="{ relatedActions: relatedActions }" />
</div>

<ng-template #singleAction let-button="relatedActions[0]">
    <button
        mat-button
        matTooltipPosition="left"
        matTooltipShowDelay="1000"
        (click)="button.clickFunction($event)"
        [disabled]="button.disabled">
        @if (button.iconClasses(); as classes) {
            <mat-icon [ngClass]="classes">{{ button.icon }}</mat-icon>
        }
        {{ button.caption | translate }}
    </button>
</ng-template>

<ng-template #multipleOrEmpty let-relatedActions="relatedActions">
    @if (relatedActions.length > 1) {
        <button mat-button [matMenuTriggerFor]="relatedActionsDd">
            <mat-icon class="mat-icon mat-icon-no-color material-icons">more_vert</mat-icon>
        </button>
    }
</ng-template>

<mat-menu #relatedActionsDd="matMenu">
    @for (button of relatedActions; track button) {
        <button
            mat-dialog-close
            mat-menu-item
            matTooltipPosition="left"
            matTooltipShowDelay="1000"
            (click)="button.clickFunction($event)"
            [disabled]="button.isDisabled">
            @if (button.iconClasses(); as classes) {
                <mat-icon [ngClass]="classes">{{ button.icon }}</mat-icon>
            }
            {{ button.caption | translate }}
        </button>
    }
</mat-menu>
